<template>
  <div class="filter-group-pro">
    <div
      :class="filterParentNegated === 'Y' ? 'icon-un is_checked' : 'icon-un'"
      class="mb-[8px]"
      style="margin-bottom: 8px;"
      v-if="$attrs.filters.length > 1 && $attrs.groupIndex === 0 && !isFromRoma && !$attrs.isFieldFlag"
      @click="negatedChange"
    >
      非
    </div>
    <div class="group-condition">
      <div class="flex justify-between items-center" v-if="filterGroup.childConditions.length > 1 && !$attrs.isFieldFlag">
        <div class="mb-[6px]" style="margin-bottom: 6px;" :class="filterGroup.negated === 'Y' ? 'icon-un is_checked' : 'icon-un'" @click="changeNavGator">
          非
        </div>
        <el-button
          v-if="!isFromRoma"
          size="mini"
          type="text"
          @click="onDeleteGroup"
          class="delete-btn"
          :disabled="$attrs.disabled"
        >
          删除
        </el-button>
      </div>
      <filter-item
        :isFieldFlag="$attrs.isFieldFlag"
        v-bind="$attrs"
        :filterItemIndex="index"
        v-for="(item, index) in filterGroup.childConditions"
        :filterItem="item"
        :filterGroup="filterGroup"
      ></filter-item>
    </div>
    <!--    {{$attrs.filters[$attrs.groupIndex + 1].operator}}-->
    <el-select
      v-model="$attrs.filters[$attrs.groupIndex + 1].operator"
      :disabled="isFromRoma || $attrs.disabled"
      v-if="$attrs.groupIndex !== $attrs.filters.length - 1"
      style="width: 60px; margin-top: 8px;"
      size="mini"
    >
      <el-option v-for="item in connectOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
  </div>
</template>

<script>
import filterItem from '../tpl/filterItem.vue'
import { connectOptions } from '../enum.data'
import { getUUID } from '../utils'

export default {
  name: 'filterGroup',
  components: { filterItem },
  props: {
    filterGroup: {
      type: Object,
      default: () => {},
    },
    negated: {
      type: String,
      default: 'N',
    },
  },
  data() {
    return {
      getUUID,
      filterParentNegated: 'N',
      connectOptions,
    }
  },
  watch: {
    negated(val) {
      this.filterParentNegated = this.negated
    },
  },
  computed: {
    isFromRoma() {
      return this.$attrs.isFromRoma
    },
  },
  mounted() {
  },
  methods: {
    negatedChange() {
      if (this.$attrs.disabled) {
        return
      }
      this.filterParentNegated = this.filterParentNegated === 'Y' ? 'N' : 'Y'
      this.$emit('negatedChange', this.filterParentNegated)
    },
    onDeleteGroup() {
      this.$attrs.filters.splice(this.$attrs.groupIndex, 1)
      if (this.$attrs.filters.length === 1) {
        this.filterParentNegated = 'N'
        this.$emit('negatedChange', this.filterParentNegated)
      }
    },
    changeNavGator() {
      if (this.$attrs.disabled) {
        return
      }
      this.filterGroup.negated = this.filterGroup.negated === 'N' ? 'Y' : 'N'
    },
  },
}
</script>

<style lang="less">
.filter-group-pro {
  .group-condition {
    border-radius: 6px;
    border: 1px dashed #b3b3b3;
    padding: 12px;
  }

  .icon-un {
    width: 28px;
    height: 28px;
    text-align: center;
    background: #efefef;
    border: 1px #e4e4e4 solid;
    border-radius: 4px;
    line-height: 28px;
    color: #dbdbdb;
    cursor: pointer;
    font-size: 12px;

    &.is_checked {
      border-color: #008dff;
      color: var(--bi-jz-font-color);
      background: var(--color-primary);
    }
  }
}

/deep/ .delete-btn .el-button--text {
  color: var(--color-danger);
}
</style>
